import { observable } from 'mobx';
import { Model, ModelRegistry } from 'core';

export class AddressModel extends Model {
  static registryName = 'AddressModel';
  static ModelProps = {
    for: 'SpaceModel',
  };

  // company
  @observable name = '';
  @observable company = '';
  @observable address1 = '';
  @observable address2 = '';
  @observable zip = '';
  @observable province = '';
  @observable city = '';
  @observable country = null;
  @observable phone = '';
  @observable default = false;
  // local observable
  @observable loading = false;
}

ModelRegistry.add(AddressModel);
